import request from '@/utils/request'

export default {
  getList() {
    return request.get('/category/list')
  },
  getCategoryList(page, size, keyword) {
    return request.get('/category/list', {
      params: { page, size, keyword }
    })
  },
  add(data) {
    return request.post('/category/add', data)
  },
  update(data) {
    return request.put('/category/update', data)
  },
  delete(id) {
    return request.delete(`/category/delete/${id}`)
  }
}
